import { render, staticRenderFns } from "./SrProjectEdit.vue?vue&type=template&id=6ae6e1bc&"
import script from "./SrProjectEdit.vue?vue&type=script&lang=js&"
export * from "./SrProjectEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports